import { useParams, useNavigate } from "react-router-dom";
import { useApp } from "../lib/store";
import { QuoteDetailView } from "../components/QuoteDetailView";
import { ArrowLeft } from "lucide-react";

export default function QuoteDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useApp();

  return (
    <div className="space-y-5" data-testid="quote-detail-page">
      <button onClick={() => navigate("/quotes")} className="text-sm text-gray-500 hover:text-gray-900 flex items-center gap-1 transition-colors duration-150" data-testid="back-to-quotes">
        <ArrowLeft className="h-4 w-4" />{t("quotes")}
      </button>
      <QuoteDetailView quoteId={id} />
    </div>
  );
}
